import { render, staticRenderFns } from "./ClinicReviewTags.vue?vue&type=template&id=58016977&scoped=true&"
import script from "./ClinicReviewTags.vue?vue&type=script&lang=js&"
export * from "./ClinicReviewTags.vue?vue&type=script&lang=js&"
import style0 from "./ClinicReviewTags.vue?vue&type=style&index=0&id=58016977&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58016977",
  null
  
)

export default component.exports